export default __webpack_public_path__ + "static/work-23f6a28d586c5c24f054ef7f3ef83ee1.gif";